const sideNavsMaxWidth = 480;
const sideNavsMinWidth = 220;
const defaultErpSidebarWidth = 400;

export const clampErpSidebarWidth = (value: number) => Math.max(sideNavsMinWidth, Math.min(value, sideNavsMaxWidth));

export const ERP_SIDEBAR_SETTINGS_DEFAULTS = {
    collapsed: false,
    openedWidth: defaultErpSidebarWidth
}